import { Link, type LinkProps } from 'react-router';

import { clsx } from '~/styles/utils';

import { cardLinkStyle } from './CardLink.css';

type CardLinkProps = Omit<LinkProps, 'aria-label'> & {
  'aria-label': string;
};

export const CardLink = ({ ...delegated }: CardLinkProps) => {
  return <Link {...delegated} className={clsx(cardLinkStyle, delegated.className)} />;
};
